export enum Civility {
    mr = 1,
    mme
}
